/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from 'react';
import {
  Paper,
} from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import useStyle from './useStyle';
import DeviceTable from './components/DataTable/DeviceTable';
import newButton from '../../assets/img/iconos/newButton.svg';
import searchIcon from '../../assets/img/iconos/searchIcon.svg';
import ActionForm from './components/ActionForm/ActionForm';
import {
  getDevicesService,
} from '../../services';

const DeviceScreen = () => {
  const classes = useStyle();
  const [devices, setDevices] = useState();
  const [enteredFilter, setEnteredFilter] = useState('');
  const defaultData = {
    name: '',
    description: '',
    price: 4500,
    numberOfFees: 0,
    chargeFrequency: '',
    dayCharge: 0,
  };
  const [defaultValues, setDefaultValues] = useState(defaultData);
  const [popUpAction, setPopUpAction] = useState({ open: false, title: '', data: null });
  const getDevices = async () => {
    try {
      const res = await getDevicesService();
      setDevices(res?.data);
    } catch (e) {
      console.log(e);
    }
  };

  const createDevice = () => {
    setDefaultValues(defaultData);
    setPopUpAction({
      open: true,
      title: 'Crear Dispositivo',
      data: null,
    });
  };

  useEffect(() => {
    getDevices();
  }, []);

  return (
    <Paper className={classes.paper}>
      <>
        <div className={classes.root}>
          <div>
            <TextField
              className={classes.searchTextField}
              value={enteredFilter}
              onChange={(e) => setEnteredFilter(e.target.value)}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <img src={searchIcon} alt="searchIcon" style={{ paddingLeft: '10px' }} />
                  </InputAdornment>
                ),
                disableUnderline: true,
              }}
              placeholder="Buscar"
            />
            <Tooltip title="Crear banner" aria-label="Nuevo banner">
              <IconButton
                onClick={createDevice}
                style={{ fontSize: '20px', float: 'right' }}
                edge="end"
                size="small"
              >
                <img src={newButton} alt="newButton" />
              </IconButton>
            </Tooltip>
          </div>
          <DeviceTable
            setDevices={setDevices}
            devices={devices}
            setDefaultValues={setDefaultValues}
            enteredFilter={enteredFilter}
            setPopUpAction={setPopUpAction}
          />
          <ActionForm
            open={popUpAction.open}
            data={popUpAction.data}
            title={popUpAction.title}
            defaultValues={
              {
                ...defaultValues,
                max_devices_per_transaction: popUpAction.data?.max_devices_per_transaction || 0,
                numberOfFees: popUpAction.data?.amount_quotas || 0,
                dayCharge: popUpAction.data?.pay_day || 0,
                chargeFrequency: popUpAction.data?.frequency_quota || '',
              }
            }
            getDevices={getDevices}
            onClose={() => {
              setPopUpAction({ open: false, title: '', data: null });
            }}
          />
        </div>
      </>
    </Paper>
  );
};

export default DeviceScreen;
